import { useEffect, useRef } from 'react';

/**
 * Custom hook that runs an effect only once based on a condition.
 *
 * @param condition the condition that will be run in the useEffect, **don't put it into the callback**!
 * @param effect the callback to run.
 * @param deps dependencies for the useEffect.
 */
export const useEffectOnce = (
  condition: () => boolean,
  effect: React.EffectCallback,
  deps?: React.DependencyList | undefined,
) => {
  const didEffectRef = useRef(false);

  useEffect(function useEffectOnceEffectWrapper() {
    if (!didEffectRef.current && condition()) {
      didEffectRef.current = true;

      effect();
    }
  }, deps?.concat(condition));
};
